import './UploadPage.scss'
import Upload from '../../Components/Upload/Upload';

function UploadPage() {

    return (
        <div className='upload__fade-in'>
            <Upload />
        </div>
    );
}

export default UploadPage;
